'use strict';

/**
 * This is from the package 'blueagent' that justin maat made :)  This has been pulled
 * in temporarily because for some unknown reason (right now) having that package required
 * and browserify makes the lines in javascript off for debugging. I will be submitting something
 * to try and figure out what the problem is.
 */

var Promise = require('bluebird');
var blueagent = Promise.promisifyAll(require('superagent'));

blueagent.Request.prototype.cancellable = function () {
    return this.endAsync().cancellable();
};

blueagent.Request.prototype.then = function (done) {
    return this.endAsync().then(done);
};

module.exports = blueagent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/blueAgent.js
// module id = 17
// module chunks = 0